import { render } from "./RFIForm.vue?vue&type=template&id=e6b2c5fc&scoped=true"
import script from "./RFIForm.vue?vue&type=script&lang=js"
export * from "./RFIForm.vue?vue&type=script&lang=js"

import "./RFIForm.vue?vue&type=style&index=0&id=e6b2c5fc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-e6b2c5fc"

export default script